import VideoPlayer from "@/components/video-player/index.vue";

export default {
  name: "player",
  components: {
    VideoPlayer,
  },
};
